import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RegisterComponent } from './account/register/register.component';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginFormComponent } from './account/login/login.component';
import { FormsModule } from '@angular/forms';
import { ConfirmEmailComponent } from './account/confirmEmail/confirmEmail.component';
import { ManageBookingComponent } from './manage-booking/manage-booking.component';
import { appRoutingModule } from '../../src/routing/app.routing';
import { ConfirmEmailSentInfoComponent } from './account/confirmEmail/Info-confirm-email-email-sent.component';
import { HeaderComponent } from './header/header.component';
import { ForgotComponent } from './account/forgotPassword/forgot.password.component';
import { CheckInboxComponent } from './account/forgotPassword/checkInbox/check-inbox.component';
import { ResetPasswordComponent } from './account/resetPassword/reset-password.component';
import { BusinessRegisterComponent } from './account/register/business-register.component';
import { ToastrModule } from 'ngx-toastr';
import { CoreModule } from '@core/core.module';
import { CommonModule } from '@angular/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgSelectModule } from '@ng-select/ng-select';
import { StripeTableComponent } from './header/stripe-table.component';
import { FooterCompnent } from './footer/footer.component';
import { AboutComponent } from './footer/footer-components/about.component';
import { PhoneComponent } from './core/components';
import { FacebookIconComponent } from "@app/shared/icons/facebook-icon.component";
import { InstagramIconComponent } from "@app/shared/icons/instagram-icon.component";
import { SecondaryButtonComponent } from "@app/core/components/buttons/button-secondary";
import { ExternalAuthCallbackComponent } from './account/external-auth/external-auth-callback.component';
import { DataProtectionComponent } from './footer/data-protection/data-protection.component';
import { TermsAndConditionsComponent } from './footer/terms-and-conditions/terms-and-conditions.component';
import { FeaturesComponent } from './footer/features/features.component';
import { ContactComponent } from './footer/contact/contact.component';
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


@NgModule({ declarations: [
        AppComponent,
        NavMenuComponent,
        HomeComponent,
        RegisterComponent,
        LoginFormComponent,
        ConfirmEmailComponent,
        ConfirmEmailSentInfoComponent,
        HeaderComponent,
        AboutComponent,
        ForgotComponent,
        CheckInboxComponent,
        ResetPasswordComponent,
        BusinessRegisterComponent,
        ExternalAuthCallbackComponent,
        StripeTableComponent,
        FooterCompnent,
        DataProtectionComponent,
        TermsAndConditionsComponent,
        FeaturesComponent,
        ContactComponent,
        ManageBookingComponent
    ],
    bootstrap: [AppComponent],
     imports: [BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    CommonModule,
    ReactiveFormsModule,
    ToastrModule.forRoot({
        enableHtml: true,
        tapToDismiss: false,
        progressBar: true,
        closeButton: true
    }),
    appRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    CoreModule,
    NgSelectModule,
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: createTranslateLoader,
            deps: [HttpClient]
        }
    }),
    PhoneComponent, FacebookIconComponent, InstagramIconComponent, SecondaryButtonComponent], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
